var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 0H3V3H0V4H3V7H4V4H7V3H4V0Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }